import { Injectable } from '@angular/core';
import { NotificationService } from '@progress/kendo-angular-notification';
import {LanguageService} from "./language.service";

@Injectable({
  providedIn: 'root',
})
export class AppNotificationService {

  constructor(private notificationService: NotificationService,
              public languageService: LanguageService) {

  }

  showNotification(style: string, label: string) {
    let convertedStyle: any = style;
    let content = this.languageService.translateText(label);
    this.notificationService.show({
      content: content,
      cssClass: "button-notification",
      animation: { type: "slide", duration: 500 },
      position: { horizontal: "center", vertical: "top" },
      type: { style: convertedStyle, icon: true },
      hideAfter: 5000
    });
  }

  showCustomNotification(style: string, label: string) {
    let convertedStyle: any = style;
    this.notificationService.show({
      content: label,
      cssClass: "button-notification",
      animation: { type: "slide", duration: 500 },
      position: { horizontal: "center", vertical: "top" },
      type: { style: convertedStyle, icon: true },
      closable: true
    });
  }
}
